export default [{
  text: 'Open',
  value: 'open',
  color: '',
}, {
  text: 'In Progress',
  value: 'in-progress',
  color: '#f3ae46',
  dark: true,
}, {
  text: 'Completed',
  value: 'completed',
  color: 'green',
  dark: true,
}, {
  text: 'On Hold',
  value: 'on-hold',
  color: 'grey',
  dark: true,
}, {
  text: 'Obsolete',
  value: 'obsolete',
  color: 'red',
  dark: true,
}, {
  text: 'Blocked',
  value: 'blocked',
  color: '#ff7468',
  dark: true,
}];
